<template>
  <div :class="{big_wrap:showOrderMask==true}">
    <top-header-info></top-header-info>
    <top-logo state="3"></top-logo>
    <div class="check_order_wrap w">
      <div class="check_order">
        <div class="title">
          <h2>填写并核对订单信息</h2>
        </div>
        <div class="address_wrap">
          <h3>预定人信息</h3>
          <div class="address_item">
            <div>
              <b>{{orderInfo.name}}</b>
              {{orderInfo.phone}}
              <p>*凭预订手机号后4位验证开场</p>
            </div>
          </div>
        </div>
        <div class="pay_method_wrap">
          <h3>支付方式</h3>
          <div class="pay_method">
            <div
              v-for="(item,index) in payMethods"
              :key="index+1"
              @click="checkPayment=item.code"
              :style="{backgroundImage:checkPayment==item.code?`url(${payBg})`:'',color:checkPayment==item.code?'#FD6C17':''}"
            >{{item.title}}</div>
          </div>
        </div>
        <div class="order-list">
          <el-row>
            <el-col :span="12">
              <h2>商品清单</h2>
            </el-col>
            <el-col :span="12">
              <a href="#" @click="goBack"><< 返回场馆修改</a>
            </el-col>
          </el-row>
          <div class="product_type_wrap">
            <div class="products_type_tit">趣运动</div>
            <table class="product-table" cellspacing="0">
              <thead>
                <tr class="product_tit" style="background-color:#fff;height:24px">
                  <th>场地</th>
                  <th>项目</th>
                  <th>日期</th>
                  <th>场次</th>
                  <th style="color:#333;">合计</th>
                </tr>
              </thead>
              <tbody>
                <tr class="goods-item">
                  <td class="td-product">
                    <img
                      :src="orderInfo.products && orderInfo.products[0].product_image || defaultImg"
                      alt="goods"
                      align="center"
                    >
                    <p>{{orderInfo.products && orderInfo.products[0].name}}</p>
                  </td>
                  <td class="td-price">{{orderInfo.extra_data && orderInfo.extra_data[0].sport}}</td>
                  <td class="td-count">{{orderInfo.extra_data && orderInfo.extra_data[0].date | dateFormat3}}({{orderInfo.extra_data && orderInfo.extra_data[0].date | dayFormat2}})</td>
                  <td class="td-total">
                    <div v-for="(i,index) in orderInfo.extra_data" :key="index">{{i.field}} {{i.start}}-{{i.end}} {{i.price | intYuan}}</div>
                  </td>
                  <td
                    class="totalforcat red_word"
                  >{{orderInfo.totals && orderInfo.totals.sub_total.value| yuan}}</td>
                </tr>
                <tr class="td-footer">
                  <td colspan="2"></td>
                  <td colspan="3">
                    <span>凭预订手机号后4位验证开场</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="remark">
          <div>订单备注</div>
          <p>
            <textarea v-model="comment"></textarea>
          </p>
        </div>
        <div class="order-footer-info">
          <div v-for="(item,index) in orderInfo.totals" :key="index">
            {{item.title}}：
            <span :class="{red_word:index=='total'}">{{item.value | yuan}}</span>
          </div>
        </div>
      </div>

      <div class="real_pay_wrap">
        <p>
          应付总额：
          <span class="red_word">{{orderInfo.total | yuan}}</span>
        </p>
        <p>预定人： {{orderInfo.name}} {{orderInfo.phone}}</p>
        <el-button @click="checkOut">提交订单</el-button>
      </div>
    </div>
    <bottom-content></bottom-content>
    <div class="order_mask_wrap" v-if="showOrderMask">
      <div>
        <el-row class="mask_title">
          <el-col :span="23">
            <p>
              <i class="el-icon-circle-check"></i>
              支付成功！
            </p>
          </el-col>
          <el-col :span="1">
            <!-- <i class="el-icon-close"></i> -->
          </el-col>
        </el-row>
        <el-row class="mask_info">
          <el-col :span="12">
            <img :src="userOrderInfo.products && userOrderInfo.products[0].product_image || defaultImg" alt>
          </el-col>
          <el-col :span="12">
            <div class="goods_title">{{userOrderInfo.products && userOrderInfo.products[0].name}}</div>
            <ul>
              <li>
                <span>订单编号</span>
                {{userOrderInfo.id}}
              </li>
              <li>
                <span>订单信息</span>
                {{userOrderInfo.name}}{{userOrderInfo.phone}}
              </li>

              <li>
                <span>项目</span>
                {{userOrderInfo.qu_yun_dong_order && userOrderInfo.qu_yun_dong_order[0].cat_id}}
              </li>
              <li>
                <span>日期</span>
                {{userOrderInfo.qu_yun_dong_order && userOrderInfo.qu_yun_dong_order[0].date | dateFormat2}}
              </li>
              <li>
                <span>场次</span>
                <div
                  class="times"
                  v-for="item in userOrderInfo.qu_yun_dong_order"
                  :key="item.field_id"
                >{{item.field_name}} {{item.time}}-{{item.end_time}} {{item.price | intYuan}}</div>
              </li>
            </ul>
          </el-col>
        </el-row>
        <el-row class="mask_button">
          <el-col :span="12">
            <router-link :to="{name:'index'}" replace>返回首页</router-link>
          </el-col>
          <el-col :span="12">
            <router-link
              :to="{name:'qyd-order-detail',params:{'order_id':userOrderInfo.id}}"
              replace
            >查看订单</router-link>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import HomeBanner from "@/components/home-banner";
import AddressList from "@/components/address-list";
import { Loading } from "element-ui";
import PAYCHECKED from "@/assets/images/pay_checked.png";
import DEFAULTGOODS from "@/assets/images/goods_default.jpg";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    HomeBanner,
    AddressList
  },
  data() {
    return {
      payBg: PAYCHECKED,
      loadingOption: { background: "rgba(0,0,0,0)" },
      payMethods: [
        { code: "alipay_direct", method: "aliWeb", title: "支付宝即时到账" },
        { code: "qrcode_wxpay", method: "wxScan", title: "微信扫码支付" }
      ],
      creditPay: [{ code: "credit", method: "scorePay", title: "账户余额" }],
      checkPayment: "",
      comment: "",
      showOrderMask: false,
      userOrderInfo: "",
      orderInfo: "",
      defaultImg:DEFAULTGOODS
    };
  },
  mounted() {
    this.orderInfo = JSON.parse(sessionStorage.getItem("orderInfo"));
    if (this.orderInfo.total == 0) {
      this.payMethods = this.creditPay;
    }
    this.checkPayment = this.payMethods[0].code;
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    open(mes) {
      this.$alert(mes, "", {
        confirmButtonText: "确定"
      });
    },
    checkOut() {
      if (!this.checkPayment) {
        this.open("请选择支付方式");
        return;
      }

      let userData = JSON.parse(sessionStorage.getItem("reserveInfo"));
      userData.payment_code = this.checkPayment;
      userData.comment = this.comment;
      this.$reqPost("api/store/quyundong_order", userData).then(res => {
        if (res.data.success) {
          this.$reqGet("api/store/quyundong_order/" + res.data.data.id).then(
            res => {
              this.userOrderInfo = res.data.data.order;
            }
          );
          if (this.checkPayment == "credit") {
            this.showOrderMask = true;
            return;
          }
          this.$router.push({
            name: "qyd-submit-order",
            params: { order_id: res.data.data.id }
          });
        }
      });
    },

    open(mes) {
      this.$alert(mes, "", {
        confirmButtonText: "确定"
      });
    },
    open2(mes) {
      this.$message({
        message: mes,
        type: "success"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.big_wrap {
  height: 100vh;
  overflow: hidden;
}
.address_item {
  width: 220px;
  height: 132px;
  padding: 30px 10px;
  box-sizing: border-box;
  background-image: url("../../assets/images/check_bg.png");
  background-size: cover;
}
.check_order_wrap {
  .check_order {
    padding: 20px 15px;
    background-color: #fff;
    .title {
      border-bottom: 2px solid #ececec;
      h2 {
        width: 240px;
        font-size: 24px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        margin: 0;
        padding-left: 5px;
        border-bottom: 2px solid #e2333f;
      }
    }
    h3 {
      font-size: 20px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 35px;
    }
    .pay_method_wrap {
      .pay_method {
        display: flex;
        > div {
          width: 120px;
          height: 35px;
          line-height: 35px;
          text-align: center;
          margin-right: 10px;
          border: 1px solid rgba(218, 218, 218, 1);
          cursor: pointer;
        }
      }
    }
    .order-list {
      h2 {
        font-size: 24px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
      }
      .el-row > div:last-child {
        text-align: right;
        a {
          margin-top: 10px;
        }
      }
      .product_type_wrap {
        margin-bottom: 20px;
      }
      .products_type_tit {
        color: #999;
        border-bottom: 2px solid #e2333f;
        font-size: 16px;
        margin-bottom: 22px;
        padding-bottom: 4px;
      }
      .product-table {
        width: 1110px;
        margin: 0 0 0 30px;
        background-color: #fafafa;
        border: none;
        thead {
          color: #999;
        }
        .goods-item {
          td {
            min-width: 100px;
            padding: 10px 15px;
            border: 0.5px solid #eee;
            text-align: center;
          }
          .td-product {
            width: 300px;
            text-align: left;
            img {
              width: 60px;
              height: 60px;
              margin: 10px 10px 10px 0;
            }
            p {
              display: inline-block;
              width: 225px;
            }
          }
          .td-total {
            line-height: 24px;
          }
          .totalforcat {
            background-color: #fff;
            color: #fc0010;
            font-size: 18px;
          }
        }
      }
      .td-footer {
        height: 80px;
        background: #fffaee;
        color: #333;
        text-align: center;
        td {
          border: 0.5px solid #eee;
        }
        span {
          color: #999;
        }
        .change-time {
          width: 120px;
          height: 30px;
          line-height: 30px;
          padding: 0;
          background: rgba(226, 51, 63, 1);
          border: 1px solid rgba(226, 51, 63, 1);
          border-radius: 15px;
          margin-left: 10px;
          color: #fff;
          span {
            color: #fff;
          }
        }
      }
    }
    .remark {
      margin-top: 20px;
      > div {
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 34px;
      }
      p {
        background-color: #fffaee;
        padding: 19px 112px 19px 28px;
        textarea {
          width: 1000px;
          height: 66px;
          // background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(221, 221, 221, 1);
        }
      }
    }
    .order-footer-info {
      margin-top: 30px;
      border-top: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
      padding: 30px 0;
      text-align: right;
      line-height: 40px;
    }
  }
  .real_pay_wrap {
    border-top: 1px solid #e0e0e0;
    text-align: right;
    font-size: 16px;
    color: #666;
    margin-bottom: 15px;
    margin-top: 30px;
    .red_word {
      font-size: 26px;
    }
    .el-button {
      width: 160px;
      height: 48px;
      line-height: 48px;
      color: #fff;
      padding: 0;
      font-size: 16px;
      background: rgba(226, 51, 63, 1);
      border-radius: 5px;
      border-color: rgba(226, 51, 63, 1);
    }
  }
}
.red_word {
  font-weight: normal;
  color: #fc0010;
}
.mask_wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(1, 1, 1, 0.6);
  > div {
    position: absolute;
    width: 700px;
    // height: 500px;
    background: rgba(255, 255, 255, 1);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .mask_title {
    font-size: 26px;
    margin: 10px 20px;
    color: #333;
    i {
      color: #bbb;
    }
  }
  .mask_info {
    margin: 20px 80px;
    border: 1px solid #bfbfbf;
    box-sizing: border-box;
    li > span {
      text-align-last: justify;
    }

  }
  .mask_button {
    padding: 30px 150px;
    padding-top: 0;
    text-align: center;
    .el-button {
      display: inline-block;
      width: 146px;
      height: 40px;
      line-height: 40px;
      padding: 0;
      font-size: 16px;
      color: #fff;
      background: rgba(226, 51, 63, 1);
      border-radius: 5px;
      border-color: rgba(226, 51, 63, 1);
    }
    > div:last-child button {
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(219, 219, 219, 1);
      color: #333;
    }
  }
}
.order_mask_wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(1, 1, 1, 0.6);
  > div {
    position: absolute;
    width: 800px;
    padding: 0 15px;
    height: 450px;
    background: rgba(255, 255, 255, 1);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .mask_title {
    text-align: center;
    font-size: 26px;
    margin: 10px 20px;
    color: #333;
    border-bottom: 1px solid #bbb;
    i {
      color: #bbb;
    }
    .el-icon-circle-check {
      color: #5eb95a;
    }
    .el-icon-circle-close {
      color: #e2333f;
    }
  }
  .mask_info {
    > div:first-child {
      text-align: center;
      img {
        width: 190px;
        height: 190px;
        margin-top: 20px;
      }
    }
    .times {
      padding-left: 85px;
      margin-top: -30px;
    }
    .goods_title {
      font-size: 20px;
      color: rgba(0, 0, 0, 1);
      line-height: 32px;
    }
    li {
      color: #222;
      line-height: 30px;
      span {
        display: inline-block;
        width: 70px;
        color: #999;
        text-align-last: justify;
        margin-right: 10px;
      }
    }
  }
  .mask_button {
    padding: 30px 150px;
    text-align: center;
    a {
      display: inline-block;
      width: 146px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      color: #fff;
      background: rgba(226, 51, 63, 1);
      border-radius: 5px;
    }
    > div:last-child a {
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(219, 219, 219, 1);
      color: #333;
    }
  }
}
.btn-disabled {
  color: #bdbdbd !important;
  cursor: not-allowed !important;
  background-image: none !important;
  background-color: #efefef !important;
  border-color: #ddd !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/qyd-check-order.vue